import GradesEditor from "@/components/GradesEditor";
export default function FinalExamGrades() {
  return <GradesEditor mode="final-exam" />;
}
